import { render, staticRenderFns } from "./newJoin.vue?vue&type=template&id=7bf0505e&scoped=true&"
import script from "./newJoin.vue?vue&type=script&lang=js&"
export * from "./newJoin.vue?vue&type=script&lang=js&"
import style0 from "./newJoin.vue?vue&type=style&index=0&id=7bf0505e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0505e",
  null
  
)

export default component.exports